<template>
	<section class="con-1200 box-white mt-30px">
		<div class="padding_section">
			<h2 class="fs-title text-center">Cégként kötök biztosítást</h2>
			<div class="fs-desc text-center mb-30px">
				Kérjük, az alábbi adatok megadása után nyomja meg az Ajánlatkérés nyomógombot, szakértőnk hamarosan
				felkeresi az igények felmérése és a megfelelő biztosítás kiválasztása érdekében.
			</div>

			<ValidationObserver ref="form" v-slot="{ invalid, handleSubmit }" slim>
				<div class="form contact_form">
					<div class="col-w50-left mb-30px">
						<ValidationProvider name="Vezetéknév" rules="required|letter_space_hypens" v-slot="{ errors, classes }" slim>
							<div :class="classes">
								<input
									type="text"
									name="last_name"
									placeholder="Vezetéknév"
									class="w-100 field"
									v-model="message.last_name"
									data-hj-allow
								/>
							</div>
							<span class="error_message">{{ errors[0] }}</span>
						</ValidationProvider>
					</div>
					<div class="col-w50-right mb-30px">
						<ValidationProvider name="Keresztnév" rules="required|letter_space_hypens" v-slot="{ errors, classes }" slim>
							<div :class="classes">
								<input
									type="text"
									name="first_name"
									placeholder="Keresztnév"
									class="w-100 field"
									v-model="message.first_name"
									data-hj-allow
								/>
							</div>
							<span class="error_message">{{ errors[0] }}</span>
						</ValidationProvider>
					</div>
					<div class="col-w100 mb-30px">
						<ValidationProvider
							name="Cégnév"
							rules="required|alpha_spaces"
							v-slot="{ errors, classes }"
							slim
						>
							<div :class="classes">
								<input
									type="text"
									name="company_name"
									placeholder="Cégnév"
									class="w-100 field"
									v-model="message.company_name"
									data-hj-allow
								/>
							</div>
							<span class="error_message">{{ errors[0] }}</span>
						</ValidationProvider>
					</div>
					<div class="col-w50-left mb-30px" style="margin-right: 0px">
						<ValidationProvider name="Telefonszám" rules="required|phone" v-slot="{ errors, classes }" slim>
							<div :class="classes">
								<input
									type="text"
									name="phone"
									placeholder="Telefonszám"
									class="w-100 field"
									v-model="message.phone"
									data-hj-allow
								/>
							</div>
							<span class="error_message">{{ errors[0] }}</span>
						</ValidationProvider>
					</div>
					<div class="col-w50-right mb-30px float-right">
						<ValidationProvider name="E-mail cím" rules="required|email" v-slot="{ errors, classes }" slim>
							<div :class="classes">
								<input
									type="email"
									name="email"
									placeholder="E-mail cím"
									class="w-100 field"
									v-model="message.email"
									data-hj-allow
								/>
							</div>
							<span class="error_message">{{ errors[0] }}</span>
						</ValidationProvider>
					</div>

					<textarea
						name="message"
						cols="30"
						rows="10"
						placeholder="Üzenet"
						class="field textarea"
						v-model="message.text"
					></textarea>
					<div class="d-flex flex-column">
						<div class="d-flex flex-m-column">
							<ValidationProvider
								name="Adatkezelési tájékoztató"
								:rules="{ required: { allowFalse: false } }"
								v-slot="{ errors, classes }"
								slim
							>
								<div class="d-flex flex-column col-w100-chbox">
									<div class="d-flex flex-column w-100">
										<div
											:class="classes"
											class="d-flex chbox_style-wrapper mt-30px mb-30px mt-m-15px mb-m-15px checkbox-field"
										>
											<input
												type="checkbox"
												class="field"
												v-model="message.data_protection"
												id="privacyPolicy"
												data-hj-allow
											/>
											<span class="chbox_style"></span>
											<label for="privacyPolicy">
												Elolvastam és elfogadom az
												<a href="/adatvedelem" target="_blank">Adatkezelésről</a>
												<br />
												szóló tájékoztatóban foglaltakat.
											</label>
										</div>
									</div>
									<span class="error_message">
										{{ errors[0] }}
									</span>
								</div>
							</ValidationProvider>
						</div>
						<span class="d-flex justify-center error_message error_message--broke" v-if="error">
							{{ error }}
						</span>
						<span class="d-flex justify-center success_message" v-if="success">
							{{ success }}
						</span>

						<div class="d-flex justify-center">
							<LoadingButton
								class="btn btn-blue"
								text="Ajánlatkérés"
								:disabled="invalid"
								:loading="loading"
								@click="handleSubmit(handleSend)"
							/>
						</div>
					</div>
				</div>
			</ValidationObserver>
		</div>
	</section>
</template>

<script>
import { mapActions } from 'vuex';
import LoadingButton from '@/components/elements/LoadingButton';

// outside of the component:
function initialState() {
	return {
		message: {
			company_name: null,
			name: null,
			email: null,
			postal_code: null,
			phone: null,
			text: null,
			data_protection: false,
			subscribe: false,
		},
		success: null,
		error: null,
		loading: false,
	};
}

export default {
	components: {
		LoadingButton,
	},
	data: function () {
		return initialState();
	},
	methods: {
		...mapActions(['sendCompanyMessage']),
		async handleSend() {
			this.loading = true;
			const response = await this.sendCompanyMessage(this.$data.message);

			if (response.success) {
				this.clear();
				this.success = response.message;
				this.$refs.form.reset();
			} else {
				this.loading = false;
				this.error = response.message;
			}
		},
		clear() {
			Object.assign(this.$data, initialState());
		},
	},
};
</script>
